import { z } from "zod";

/**
 * System Agent Message ID (AI SDK message.id)
 *
 * This is the stable identifier used by the system-agent chat UI and persisted
 * in the database as `payload.id`. It must NOT be confused with the database
 * message primary key (BigInt).
 *
 * Branded type provides compile-time type safety. Runtime validation ensures
 * it's a non-empty string (AI SDK message IDs are strings, format varies).
 */
export const SystemAgentMessageIdSchema = z
	.string()
	.min(1)
	.brand("SystemAgentMessageId");

export type SystemAgentMessageId = z.infer<typeof SystemAgentMessageIdSchema>;

export function createSystemAgentMessageId(
	value: string
): SystemAgentMessageId {
	return SystemAgentMessageIdSchema.parse(value);
}

export function isSystemAgentMessageId(
	value: unknown
): value is SystemAgentMessageId {
	return SystemAgentMessageIdSchema.safeParse(value).success;
}
